module.exports = __webpack_public_path__ + "static/img/banner@3x.5da8c98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner@3x.png
// module id = q7kl
// module chunks = 1